<template>
  <div class="dataTable" :class="roundClass">
    <div class="flex gap-[1px]">
      <div v-for="(column, i) in columns" :key="i" class="tHeader cell" :class="[column.colClass, column.headClass]" >
        <template v-if="typeof column.title === 'function'">
          <component :is="column.title(column, i) || null" />
        </template>
        <template v-else>
          {{ column.title }}
        </template>
      </div>
    </div>
    <div v-if="data.length">
      <div v-for="(row, i) in data" :key="i" class="dataList">
        <div v-for="(column, j) in columns" :key="j" class="flex-center flex-1 cell" :class="[column.colClass, column.bodyClass]">
          <template v-if="column.render">
            <component :is="column.render(row, i, j) || null" />
          </template>
          <template v-else>
            {{ row[column.key] }}
          </template>
        </div>
      </div>
    </div>
    <NoData v-else />
  </div>
</template>

<script setup lang="ts">
  import NoData from '@/components/NoData/index.vue'

  const props = withDefaults(defineProps<{
    columns: {title: string | ((column: any, i: number) => any), render?: (row: any, i: number, j: number) => any, key: string, colClass?: string, headClass?: string, bodyClass?: string}[]
    data: any[]
    round?: boolean | 'cell'
    headBgColor?: string
    bodyBgColor?: string[]
  }>(), {
    round: false,
    headBgColor: 'var(--title-bg-color)',
    bodyBgColor: () => ['var(--odd-bg-color)', 'var(--even-bg-color)']
  })

  const headBgColor = computed(() => props.headBgColor)
  const bodyBgColorOdd = computed(() => props.bodyBgColor[0])
  const bodyBgColorEven = computed(() => props.bodyBgColor[1] || props.bodyBgColor[0])
  const roundClass = computed(() => props.round === 'cell' ? 'round-cell' : (props.round ? 'round' : ''))
</script>

<style lang="scss" scoped>
.dataTable{
  @apply w-full flex flex-col gap-0.5 overflow-hidden;

  &.round{
    @apply rounded-[var(--dataTable-table-radius)];
  }

  &.round-cell{
    .cell {
      @apply rounded-[var(--dataTable-cell-radius)] overflow-hidden;
    }
  }

  .tHeader{
    @apply flex-1 text-13 min-h-[var(--dataTable-head-height)] flex-center text-center;

    background-color: v-bind(headBgColor);
  }

  .dataList{
    @apply min-h-[var(--dataTable-line-height)] flex gap-[1px] mb-[2px] last:mb-0;

    >div{
      background-color: v-bind(bodyBgColorOdd);
    }

    &:nth-child(even) > div{
      background-color: v-bind(bodyBgColorEven);
    }
  }
}
</style>
